import apiClient from './base/apiClient'

export interface ReviewKeyword {
  id: number
  name: string
  order: number
}

export interface GetReviewKeywordsResponse {
  keywords: ReviewKeyword[]
}

export interface SuggestReviewKeywordRequest {
  suggestionText: string
}

export interface SuggestReviewKeywordResponse {
  message: string
}

export const reviewKeywordApi = {
  getKeywords: async (): Promise<GetReviewKeywordsResponse> => {
    const response = await apiClient.get<GetReviewKeywordsResponse>(
      '/review-keywords'
    )
    return response.data
  },
  suggestKeyword: async (
    data: SuggestReviewKeywordRequest
  ): Promise<SuggestReviewKeywordResponse> => {
    const response = await apiClient.post<SuggestReviewKeywordResponse>(
      '/review-keywords/suggest',
      {
        suggestionText: data.suggestionText,
      }
    )
    return response.data
  },
}
